import * as React from 'react';
import Modal from 'react-modal';

import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph';
import LoadingIndicator from 'components/LoadingIndicator';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';

import SplitComposerModal from './SplitComposerModal';
import { MessageType } from './SplitComposer';
import Token from './ComposeMessageRecipientToken';
import { ComposerStateContext } from 'chat_v2/ComposerContext';

type Props = {
  onClick: () => void;
  messageType: MessageType;
  // data loader
  groupsLoading?: boolean;
  orgsLoading?: boolean;
};

export default function ComposeMessageRecipientsInput(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { messageType, groupsLoading, orgsLoading, onClick = () => {} } = props;
  return (
    <ComposerStateContext.Consumer>
      {composerContext => (
        <>
          <Modal isOpen={isOpen}>
            <SplitComposerModal
              onComposerPage
              messageType={messageType}
              onRequestHide={() => setIsOpen(false)}
            />
          </Modal>
          <div
            className="ComposeMessageRecipientsInput"
            onClick={() => {
              EventTracking.trackKey('announcements.share_to.input.click');
              setIsOpen(true);
              onClick();
            }}
            data-test-selector="split-composer-recipients-input">
            <MediaObject
              center
              figure="right"
              gutter="xsmall"
              className="ComposeMessageRecipientsInput-inner">
              <MediaObject center gutter="xsmall">
                <Text size="xsmall" color="graphite">
                  To:
                </Text>
                <MediaObject center gutter="xsmall">
                  <React.Fragment>
                    {groupsLoading || orgsLoading ? (
                      <LoadingIndicator size="small" />
                    ) : Object.keys(composerContext.recipients).length ? (
                      Object.values(composerContext.recipients).map(entity => <Token entity={entity} key={entity.recipient.uuid} selectedRoles={(composerContext.filters[entity.recipient.uuid] || {})['roles']} />)
                    ) : (
                      <Text color="graphite" size="xsmall">
                        Click to select recipients
                      </Text>
                    )}
                  </React.Fragment>
                  <div /* this needs to be here or the component breaks */ />
                </MediaObject>
              </MediaObject>
              <Glyph
                className="ComposeMessageRecipientsInput-pencilIcon"
                name="pencil-stroke"
                color="graphite"
              />
            </MediaObject>
          </div>
        </>
      )}
    </ComposerStateContext.Consumer>
  );
}
